import { render, staticRenderFns } from "./ResetPasswordAdmin.vue?vue&type=template&id=8224a5fc&scoped=true&"
import script from "./ResetPasswordAdmin.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordAdmin.vue?vue&type=style&index=0&id=8224a5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8224a5fc",
  null
  
)

export default component.exports